import { Box, useMediaQuery, useTheme } from '@methanesat/ui-components';
import { BelowNavDrawer, BelowNavDrawerProps } from '../../BelowNavDrawer';
import { BottomUpDrawer } from '../../BottomUpDrawer/BottomUpDrawer';
import { SnapPointIds } from '../../../types';

export interface DrawerContainerProps extends BelowNavDrawerProps {
    open: boolean | undefined;
    title?: string;
    snapPoint: SnapPointIds;
    setSnapPoint: (s: SnapPointIds) => void;
    onClose: Exclude<BelowNavDrawerProps['onClose'], undefined>;
}

/**
 * Component that handles chosing `BelowNavDrawer` or `BottomUpDrawer`, depending on screen size.
 * Also re-wraps headers appropriately.
 */
export const DrawerContainer = ({ children, snapPoint, setSnapPoint, header, ...props }: DrawerContainerProps) => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

    if (isMobileScreen) {
        return (
            <BottomUpDrawer
                drawerContent={children}
                snapPoint={snapPoint}
                setSnapPoint={setSnapPoint}
                header={
                    <Box display="flex" width="100%">
                        {header}
                    </Box>
                }
                {...props}
            />
        );
    }

    return (
        <BelowNavDrawer
            {...props}
            header={
                <Box
                    sx={(theme) => ({
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.primary.main,
                        alignItems: 'center',
                        display: 'flex',
                        marginX: -3,
                        justifyContent: 'space-between',
                        paddingX: 2,
                        borderBottom: 1,
                        width: 'stretch'
                    })}
                >
                    {header}
                </Box>
            }
        >
            {children}
        </BelowNavDrawer>
    );
};
